// ======================================================================
// File: purchaseRequestService.js
// Module: PPE → Procurement → Purchase Request
//
// Purpose:
// - Handle all Purchase Request API calls
// - Follows exact indentService.js pattern
// - No UI logic
// - No state handling
//
// Backend base path:
// /api/ppe/material-flow/purchase-request
// ======================================================================

import axiosClient from "../../../../../../api/axiosClient";

const BASE_URL = "/api/ppe/material-flow/purchase-request";

const purchaseRequestService = {

  // ==============================================================
  // LIST PURCHASE REQUESTS
  // ==============================================================
  getPurchaseRequests(params = {}) {
    return axiosClient.get(BASE_URL, { params });
  },

  // ==============================================================
  // GET PURCHASE REQUEST DETAIL
  // ==============================================================
  getPurchaseRequestById(prId) {
    return axiosClient.get(`${BASE_URL}/${prId}`);
  },

  // ==============================================================
  // CREATE PR (HEADER ONLY)
  // ==============================================================
  createPurchaseRequest(payload) {
    return axiosClient.post(BASE_URL, payload);
  },

  // ==============================================================
  // CONSOLIDATE INDENT LINES INTO PR
  // ==============================================================
  consolidateIndentLines(prId, indentLines = []) {
    return axiosClient.post(
      `${BASE_URL}/${prId}/consolidate`,
      {
        indent_lines: indentLines,
      }
    );
  },

  // ==============================================================
  // SUBMIT PURCHASE REQUEST
  // ==============================================================
  submitPurchaseRequest(prId, payload = {}) {
  return axiosClient.post(
    `${BASE_URL}/${prId}/submit`,
    payload
  );
},

  // ==============================================================
  // APPROVE PURCHASE REQUEST
  // ==============================================================
  approvePurchaseRequest(prId) {
    return axiosClient.post(`${BASE_URL}/${prId}/approve`);
  },

  rejectPurchaseRequest(prId) {
  return axiosClient.post(`${BASE_URL}/${prId}/reject`);
  },

  cancelPurchaseRequest(prId) {
  return axiosClient.post(
    `${BASE_URL}/${prId}/cancel`
  );
},
  // ==============================================================
  // NEW METHOD – GET APPROVED INDENT LINES FOR CONSOLIDATION
  // (ADDED – EXISTING METHODS NOT TOUCHED)
  // ==============================================================
  getApprovedIndentLinesForPR(params = {}) {
    return axiosClient.get(
      `${BASE_URL}/approved-indent-lines`,
      { params }
    );
  },

};

export default purchaseRequestService;
